import { createSelector } from 'reselect';
import _ from 'lodash';
import {
  navigationRoutes,
  navigationSteps
} from '../navigation/navigationHelpers';

// Flow is determined by the route and returns 1 of the first 3 values
// FlowType is coming back with either "MyPlan" or "MoveRepackage"
export const errorPageConfig = {
  'myPlan': navigationRoutes[navigationSteps.myPlan.ERROR].path,
  'movers': navigationRoutes[navigationSteps.movers.ERROR].path,
  'quickCheckout': navigationRoutes[navigationSteps.quickCheckout.ERROR].path,
  'MyPlan': navigationRoutes[navigationSteps.myPlan.ERROR].path,
  'MoveRepackager': navigationRoutes[navigationSteps.movers.ERROR].path
};

export const commonSelector = state => state.common;

// get flow from state
export const flowSelector = createSelector(
  commonSelector,
  common => _.get(common, 'flow', '')
);

export const flowTypeSelector = createSelector(
  commonSelector,
  common => _.get(common, 'flowType', '')
);

export const commonErrorsSelector = createSelector(
  commonSelector,
  common => _.get(common, 'error.errors', [])
);

export const errorPageByFlow = createSelector(
  flowSelector,
  flowTypeSelector,
  (flow, flowType) => _.get(errorPageConfig, flowType ? flowType : flow, navigationRoutes[navigationSteps.myPlan.ERROR].path)
);

export const osFamilySelector = createSelector(
  commonSelector,
  common => _.get(common, 'platform.os.family', '')
);

export const isMobileSelector = createSelector(
  osFamilySelector,
  os => os == "iOS" || os == "Android"
);



/** WEBPACK FOOTER **
 ** ./client/redux/modules/common/commonSelectors.js
 **/